"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var R = _interopRequireWildcard(require("ramda"));
var _reactI18next = require("react-i18next");
var _reactScroll = require("react-scroll");
var _connectedReactRouter = require("connected-react-router");
var _reactBeautifulDnd = require("react-beautiful-dnd");
var _reactDeviceDetect = require("react-device-detect");
var _Loader = _interopRequireDefault(require("../../../ui/Loader"));
var _Alert = _interopRequireWildcard(require("../../../ui/Alert"));
var _book = require("../../../routes/book");
var _actions = require("../../store/actions");
var _selectors = require("../../store/selectors");
var _Basket = _interopRequireDefault(require("./components/Basket"));
var _BasketInfo = _interopRequireDefault(require("./components/BasketInfo"));
var _EditForm = _interopRequireDefault(require("./components/EditForm"));
var _Offer = _interopRequireDefault(require("./components/Offer"));
var _OffersDragDropProvider = require("./components/OffersDragDropProvider");
var _helpers = require("./helpers");
var _styles = _interopRequireDefault(require("./styles"));
var _move = _interopRequireDefault(require("./img/move.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var mapIndexed = R.addIndex(R.map);
var Results = function Results() {
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.getSearchBasketFormUi),
    completed = _useSelector.completed,
    loading = _useSelector.loading,
    error = _useSelector.error,
    message = _useSelector.message;
  var baskets = (0, _reactRedux.useSelector)(_selectors.getBasketsByOrder);
  var initialOpenedBasketId = (0, _reactRedux.useSelector)(_selectors.getInitialOpenedBasketId);
  var dispatch = (0, _reactRedux.useDispatch)();
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKETS_SEARCH_FORM'),
    t = _useTranslation.t;
  (0, _react.useEffect)(function () {
    if (initialOpenedBasketId && completed) {
      _reactScroll.scroller.scrollTo((0, _helpers.createBasketId)(initialOpenedBasketId), {
        duration: 500,
        delay: 0,
        smooth: true,
        isDynamic: true,
        offset: 0.6
      });
      dispatch((0, _connectedReactRouter.replace)(_book.book.carts));
    }
  }, [initialOpenedBasketId, completed, dispatch]);
  var onRemoveOffer = (0, _react.useCallback)(function (offerID, basketID) {
    dispatch((0, _actions.startRemoveOfferFromBasket)(offerID, basketID));
  }, [dispatch]);
  var onMoveOfferInBasket = (0, _react.useCallback)(function (_ref) {
    var offerID = _ref.draggableId,
      destination = _ref.destination;
    dispatch((0, _actions.moveOfferInBasket)(offerID, destination.index));
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loading && /*#__PURE__*/_react.default.createElement(_Loader.default, null), error && message, !R.isEmpty(baskets) && completed && R.map(function (_ref2) {
    var id = _ref2.id,
      offersIDs = _ref2.offersIDs,
      discount = _ref2.discount,
      margin = _ref2.margin,
      showPriceWithMargin = _ref2.showPriceWithMargin,
      round = _ref2.round;
    return /*#__PURE__*/_react.default.createElement(_Basket.default, {
      basketID: id,
      initialOpen: initialOpenedBasketId === id,
      key: id
    }, /*#__PURE__*/_react.default.createElement(_OffersDragDropProvider.OffersDragDropProvider, {
      onDragEnd: onMoveOfferInBasket
    }, mapIndexed(function (offerID, index) {
      return /*#__PURE__*/_react.default.createElement(_reactBeautifulDnd.Draggable, {
        draggableId: offerID,
        index: index,
        key: offerID
      }, function (dragProvided) {
        return /*#__PURE__*/_react.default.createElement("div", _extends({
          ref: dragProvided.innerRef
        }, dragProvided.draggableProps), /*#__PURE__*/_react.default.createElement(_Offer.default, {
          dragNode: /*#__PURE__*/_react.default.createElement("div", _extends({
            className: _styles.default.moveButton,
            dangerouslySetInnerHTML: {
              __html: _move.default
            }
          }, dragProvided.dragHandleProps)),
          isMobile: _reactDeviceDetect.isMobileOnly,
          basketID: id,
          discount: discount,
          margin: margin,
          round: round,
          offerID: offerID,
          showPriceWithMargin: showPriceWithMargin,
          onRemove: onRemoveOffer
        }));
      });
    }, offersIDs)), /*#__PURE__*/_react.default.createElement("div", {
      className: _styles.default.footer
    }, /*#__PURE__*/_react.default.createElement(_EditForm.default, {
      basketID: id
    }), /*#__PURE__*/_react.default.createElement(_BasketInfo.default, {
      basketID: id
    })));
  }, baskets), R.isEmpty(baskets) && completed && /*#__PURE__*/_react.default.createElement(_Alert.default, {
    type: _Alert.TYPES.DANGER
  }, t('EMPTY_BASKETS_STATE')));
};
var _default = exports.default = (0, _react.memo)(Results);